import { Backdrop, Fade, Popper, PopperPlacementType } from '@mui/material';
import React, { FC, ReactNode } from 'react';
import styles from './Bubble.module.css';

interface BubbleProps { children: ReactNode, anchorEl, open: boolean, placement: PopperPlacementType }

const Bubble: FC<BubbleProps> = ({ children, anchorEl, open, placement }) => {

    const id = open ? 'simple-popper' : undefined;

    return (<div className={styles.Bubble} data-testid="Bubble">
        <Backdrop sx={{ color: '#fff', backgroundColor: 'rgba(255,255,255,0.5)', zIndex: (theme) => theme.zIndex.drawer + 1400 }}
            open={open}
        >
            <Popper id={id} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1500 }} open={open} anchorEl={anchorEl} placement={placement} transition >
                {({ TransitionProps }) => {
                    return <Fade {...TransitionProps} timeout={1000}>
                        <div>
                            <div className={styles.triangle}>
                                <svg className={styles.triangleTopLeft} viewBox="0 0 100 100">
                                    <polyline points="100 50, 0 3, 100 3" fill="white" stroke="black" strokeWidth="5" />
                                </svg>
                                <svg className={styles.triangleBottomLeft} viewBox="0 0 100 100">
                                    <polyline points="100 97, 0 97, 100 50" fill="white" stroke="black" strokeWidth="5" />
                                </svg>
                                <svg className={styles.triangleBottomRight} viewBox="0 0 100 100">
                                    <polyline points="0 97, 100 97, 0 50" fill="white" stroke="black" strokeWidth="5" />
                                </svg>
                                <svg className={styles.triangleTopRight} viewBox="0 0 100 100">
                                    <polyline points="0 3, 100 3, 0 50" fill="white" stroke="black" strokeWidth="5" />
                                </svg>
                            </div>
                            <div className={styles.popperSpace}>
                                {children}
                            </div>
                        </div>
                    </Fade>
                }}
            </Popper>
        </Backdrop>
    </div>)
}
export default Bubble;
